import { render, staticRenderFns } from "./LicensePlate.vue?vue&type=template&id=f10b135a&"
import script from "./LicensePlate.controller.js?vue&type=script&lang=js&"
export * from "./LicensePlate.controller.js?vue&type=script&lang=js&"
import style0 from "./LicensePlate.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports